export default __webpack_public_path__ + "4663b13f671592000fb5a4f69ada87b9.png";